import { useState } from "react";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { ISHIKAWA_CATS } from "../../lib/eightd";
import { Plus, X, GitBranch } from "lucide-react";

// 6M Ishikawa (fishbone) root-cause editor. value: { man:[], machine:[], ... }
export function Ishikawa({ value = {}, onChange, disabled }) {
  const [drafts, setDrafts] = useState({});
  const add = (cat) => {
    const txt = (drafts[cat] || "").trim();
    if (!txt) return;
    onChange({ ...value, [cat]: [...(value[cat] || []), txt] });
    setDrafts((d) => ({ ...d, [cat]: "" }));
  };
  const remove = (cat, i) => onChange({ ...value, [cat]: (value[cat] || []).filter((_, idx) => idx !== i) });

  return (
    <div data-testid="ishikawa-panel">
      <h3 className="text-sm font-semibold text-[#1B2A4A] flex items-center gap-1.5 mb-3">
        <GitBranch className="h-3.5 w-3.5" />Ishikawa – Ursachenanalyse (6M)
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {ISHIKAWA_CATS.map((c) => (
          <div key={c.key} className="border border-gray-100 rounded-lg p-3" data-testid={`ishikawa-${c.key}`}>
            <Label className="text-xs font-semibold text-gray-600">{c.label}</Label>
            <div className="mt-2 space-y-1.5">
              {(value[c.key] || []).map((cause, i) => (
                <div key={i} className="flex items-center gap-1.5 text-xs bg-gray-50 rounded-md px-2 py-1" data-testid={`ishikawa-cause-${c.key}-${i}`}>
                  <span className="flex-1 break-words">{cause}</span>
                  {!disabled && <button onClick={() => remove(c.key, i)} className="text-gray-400 hover:text-red-600" data-testid={`ishikawa-remove-${c.key}-${i}`}><X className="h-3 w-3" /></button>}
                </div>
              ))}
              {(value[c.key] || []).length === 0 && <p className="text-[11px] text-gray-300">–</p>}
            </div>
            {!disabled && (
              <div className="flex items-center gap-1.5 mt-2">
                <Input className="h-8 text-xs" placeholder="Ursache…" data-testid={`ishikawa-input-${c.key}`}
                  value={drafts[c.key] || ""} onChange={(e) => setDrafts((d) => ({ ...d, [c.key]: e.target.value }))}
                  onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(c.key); } }} />
                <button onClick={() => add(c.key)} data-testid={`ishikawa-add-${c.key}`}
                  className="h-8 w-8 shrink-0 rounded-md bg-[#1B2A4A] text-white flex items-center justify-center hover:bg-[#24365d]">
                  <Plus className="h-3.5 w-3.5" />
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
